import React from 'react';
import { Col } from 'react-bootstrap';
import { useQuery } from '@apollo/react-hooks';
import { FetchProductData } from '../../grappql/Product/Queries/Product';
import ProductGridNew2 from '../../ProductListing/ProductGrid/ProductGridNew2';

const isTenMinutesLeft = (sDate) => {
    if (!sDate) return false;
    const diff = new Date(sDate) - new Date();
    return diff > 0 && diff < 10 * 60 * 1000;
};

const isProgramOver = (sDate) => {
    if (!sDate) return false;
    return new Date(sDate) < new Date();
};

export const LoveItem = (props) => {
    const { loading, data } = useQuery(FetchProductData, {
        variables: { handle: props.productHandle }
    });

    if (loading) return <Col xs={12} md="auto"><div style={{ width: 324, maxWidth: '100%', height: 480, background: '#f8f3ec', borderRadius: 8 }} /></Col>;
    if (!data || data.product === null) return null;

    return (
        <Col xs={12} md="auto">
            <ProductGridNew2
                product={data.product}
                AddtoCart={props.AddtoCart}
                Program_structure_images={props.Program_structure_images || []}
                is_ten_minite_less={isTenMinutesLeft}
                program_date_is_gone_or_not={isProgramOver}
                AddtoWishlist={props.AddtoWishlist}
                getAllWishlist={props.getAllWishlist || []}
                bookmarkAddedLabel="Remove from bookmarks"
                GAurl=""
            />
        </Col>
    );
};
